module.exports = __webpack_public_path__ + "media/images/icons/facebook_circle_2-7827707ca93743736e524c2cf069ff99.png";